// @file Entrypoint for auth signup page
import { configure as configureArvo } from '@padlet/arvo'
import { captureException } from 'bits/error_tracker'
import { ww } from 'bits/global'
import { setupVueApp } from 'bits/vue'
import AuthSignupApp from 'vuecomponents/AuthSignupApp.vue'
import { storeOptions } from 'vuexstore/landside'

async function configureApi(): Promise<void> {
  const { arvoConfig } = ww.vueStartingState
  void configureArvo(arvoConfig)
}

void setupVueApp({
  el: '#auth_signup_app',
  rootComponent: AuthSignupApp,
  beforeMountPromises: [configureApi()],
  storeOptions,
  usePinia: true,
  initializeStore(store): void {
    store.dispatch('initializeState', ww.vueStartingState).catch(captureException)
  },
})
